import { useId } from "react";

import BaseAction from "ds/components/BaseAction";
import Typography from "ds/components/Typography";

import { RunShortcut } from "../../types";
import styles from "./styles.module.css";
import NavigationBarActionKeys from "./ActionKeys";

type NavigationBarActionProps = RunShortcut;

const NavigationBarAction = ({
  callback,
  disabled,
  code,
  label,
  loading,
}: NavigationBarActionProps) => {
  const labelId = useId();

  return (
    <BaseAction
      className={styles.shortcut}
      onClick={callback}
      disabled={loading || disabled}
      aria-labelledby={labelId}
    >
      <NavigationBarActionKeys code={code} />
      <Typography tag="span" variant="p-body4" color="secondary" id={labelId}>
        {label}
      </Typography>
    </BaseAction>
  );
};

export default NavigationBarAction;
